import React from 'react'

interface ColumnHeaderProps extends Omit<React.HTMLAttributes<HTMLTableCellElement>, 'className'> {
  children?: React.ReactNode;
}

export function ColumnHeader ({ children, ...props }: ColumnHeaderProps) {
  return (
    <th
      {...props}
      className='first:w-36 font-semibold text-left align-top text-gray-800 bg-white p-4 border-gradient-to-b from-gray-300 to-gray-200 [&:nth-child(2)]:before:pl-0 !sticky top-0'
      scope='col'
    >
      {children}
    </th>
  )
}

ColumnHeader.displayName = 'PlanTable.ColumnHeader'
